import { IconButton, PenIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';
import { ExperienceResource } from '../../../../../Types';
import ExperienceContent from './ExperienceContent';
import ProgramHours from './ProgramHours';

interface Props {
  experienceResource: ExperienceResource;
  selectedDateIds?: Set<number>;
  onEditDates?: () => void;
}

function ExperienceBody({ experienceResource, selectedDateIds, onEditDates }: Props) {
  const isScheduledProgram = experienceResource.payload.offering_type === 'epc';
  const startDatesCount = experienceResource.payload.program_instance_options.scheduled.length;
  // Show selected count if available, otherwise show total available dates
  const displayCount = selectedDateIds?.size ?? startDatesCount;

  return (
    <div className="flex flex-auto flex-col gap-4 lg:flex-row">
      <div className="order-2 flex flex-col lg:order-1">
        <div className="flex flex-col gap-y-3">
          <Typography
            className="cursor-pointer text-foreground"
            variant="bodyMedium"
            as="h5"
            fontWeight="medium"
          >
            {experienceResource.payload.title}
          </Typography>
          <div className="flex flex-wrap gap-x-3 gap-y-1 empty:hidden sm:gap-x-6">
            <span className="text-foreground text-xs">
              <T
                kind={`{{count}} Competency`}
                count={experienceResource.payload.competency_count}
              />
            </span>
            <ProgramHours experienceResource={experienceResource} />
            {isScheduledProgram && startDatesCount > 0 && (
              <div className="flex items-center">
                <span className="text-foreground text-xs">
                  <T kind={`{{count}} Date`} count={displayCount} />
                </span>
                {onEditDates && (
                  <IconButton
                    onClick={onEditDates}
                    className="p-0 ml-1 opacity-0 group-hover:opacity-100 transition-opacity"
                    data-intercom-target="builder-v2-edit-dates-button"
                    aria-label="Edit program dates"
                  >
                    <PenIcon size="xs" />
                  </IconButton>
                )}
              </div>
            )}
          </div>
          <ExperienceContent experienceResource={experienceResource} />
        </div>
      </div>
    </div>
  );
}
export default observer(ExperienceBody);
